import { Component } from '@angular/core';
import { PlansComponent } from '../plans/plans.component';
import { RouterModule } from '@angular/router';
import { BuyBookComponent } from "../../../../buy-book/buy-book.component";

@Component({
  selector: 'app-product',
  standalone: true,
  imports: [PlansComponent, RouterModule, BuyBookComponent],
  templateUrl: './product.component.html',
  styleUrl: './product.component.css'
})
export class ProductComponent {

  ngAfterViewInit(): void {
    // Only run in the browser
    if (typeof document === 'undefined') return;

    const script = Object.assign(document.createElement('script'), {
      src: 'assets/js/all-instructor-custom.js',
      async: true
    });

    document.body.appendChild(script);
  }
}
